import mapFunction from './mapResources';

export default mapFunction('today_info', {
    isFetching: false,
    items: [] 
});